@if (loading$ | async) {
    <app-loader></app-loader>
}
@if (customerDetails$ | async; as details) {
    <code></code>
}
@if (errors$ | async; as error) {
    <app-evida-error [error]="error" [errorCode]="error.status">
        {{ error.message }}
    </app-evida-error>
}
